import React from "react";

const CustomRadio = ({ label, desc, value, selected, onChange }) => {
    return (
        <div
            className={`flex justify-between items-start w-full p-4 rounded-xl cursor-pointer transition 
        ${selected ? "border border-primary bg-[#FFF5F2]" : "border border-gray-300 bg-white"}`}
            onClick={() => onChange(value)}
        >
            {/* Left side: label + optional description */}
            <div className="flex flex-col">
                <span className="text-gray-800 font-medium capitalize">{label}</span>
                {desc && (
                    <span className="text-[14px] mt-1" style={{ color: "#013135A1" }}>
                        {desc}
                    </span>
                )}
            </div>

            {/* Circle */}
            <div
                className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition
          ${selected ? "border-primary bg-primary" : "border-gray-400 bg-white"}`}
            >
                {selected && (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={3}
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                )}
            </div>
        </div>
    );
};

export default CustomRadio;
